import './MobilePage.css'
import SphereLogo from "../../Assets/Images/SphereLogo.png"; 


function MobilePage() { 
    return (
        <div style={{
            textAlign:'center', 
            position: 'absolute', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)', 
        }}> 
            <img style={{maxWidth: '90%', height:'auto'}} src={SphereLogo} alt=''/>
            <h3 style={{color:'#969696'}}>Sphere Audio Portal</h3>
            <p style={{color:'#969696'}}>Please View on a Desktop Browser</p>
        </div>
    )
}


export default MobilePage;